import ReactGA from 'react-ga4';

export const logPageView = (path: string) => {
  ReactGA.event(path);
};
